import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { isInvitationTypeValid } from '@/utils/accept';
import Register from '@/views/Register.vue';

export const registerRoute: RouteConfig = {
  path: '/register/:type?/:token?',
  name: 'register',
  component: Register,
  beforeEnter: (to: any, from: any, next: any) => {
    const isPathValid = to.params.type ? isInvitationTypeValid(to.params.type) : true;

    if (isPathValid) {
      store
        .dispatch('terms/current', { required: true })
        .then(() => next())
        .catch(() => store.dispatch('notifyError', { title: 'messages.terms.listError' }));
    } else {
      next({
        path: '/login'
      });
    }
  }
};
